<template>
    <div>
        <page-navigate></page-navigate>
        <div class="rem-container">
            <section class="section1">
                <div class="section1-inner rem-wrapper">
                    <div class="section1-left">
                        <h1 v-html="$t('activityListCreatorIncentives.创作即收益')"></h1>
                        <p class="h1-intro">{{ $t('activityListCreatorIncentives.加入EBC创作者激励计划') }}</p>
                        <a href="javascript:;" @click="messageShow()"
                            class="ebc-btn-large section1-btn popup-show-btn">{{
                                $t('activityListCreatorIncentives.成为创作者') }}
                            <span class="iconfont icon-chevron_right"></span></a>
                    </div>
                    <img class="section1-bg pc" src="../assets/image/activity/creator-incentives/section1_bg.png"
                        alt="" />
                    <img class="section1-bg mobile" src="../assets/image/activity/creator-incentives/section1_bg_m.png"
                        alt="" />
                </div>
            </section>
            <section class="section2">
                <div class="section2-inner rem-wrapper">
                    <h2 class="section2-title scroll-fade-up">{{ $t('activityListCreatorIncentives.无限奖励') }}</h2>
                    <p class="title-intro scroll-fade-up">
                        {{ $t('activityListCreatorIncentives.EBC创作者激励计划') }}
                    </p>
                    <div class="section2-content">
                        <div class="section2-list">
                            <div class="section2-item">
                                <img class="section2-item-icon"
                                    src="../assets/image/activity/creator-incentives/icon1.svg" alt="" />
                                <h3 class="section2-item-title">{{ $t('activityListCreatorIncentives.推荐奖励') }}</h3>
                                <p class="section2-item-intro">
                                    {{ $t('activityListCreatorIncentives.推荐新用户注册并交易') }}
                                </p>
                            </div>
                            <div class="section2-item">
                                <img class="section2-item-icon"
                                    src="../assets/image/activity/creator-incentives/icon2.svg" alt="" />
                                <h3 class="section2-item-title">{{ $t('activityListCreatorIncentives.内容变现') }}</h3>
                                <p class="section2-item-intro">
                                    {{ $t('activityListCreatorIncentives.在EBC') }}
                                </p>
                            </div>
                            <div class="section2-item">
                                <img class="section2-item-icon"
                                    src="../assets/image/activity/creator-incentives/icon3.svg" alt="" />
                                <h3 class="section2-item-title">{{ $t('activityListCreatorIncentives.内容进阶') }}</h3>
                                <p class="section2-item-intro">
                                    {{ $t('activityListCreatorIncentives.从本地创作到全球影响') }}
                                </p>
                            </div>
                        </div>
                        <div class="section2-card">
                            <div class="section2-card-box">
                                <div class="section2-card-label">{{ $t('activityListCreatorIncentives.预计奖金') }}</div>
                                <div class="section2-card-actived-value">{{ section2Actived.label }}</div>
                            </div>
                            <div class="section2-card-list">
                                <div v-for="(item, index) in section2List" @mouseenter="section2Actived = item"
                                    :class="['lv-' + (index + 1), { 'section2-card-item-actived': section2Actived.label == item.label }]"
                                    class="section2-card-item">
                                    <div class="section2-card-item-value">{{ item.label }}</div>
                                    <div class="section2-card-item-dot"></div>
                                    <div class="section2-card-item-line"></div>
                                    <div class="section2-card-item-level">{{ item.value }}</div>
                                </div>
                            </div>
                            <div class="section2-card-tips">{{ $t('activityListCreatorIncentives.均值估算仅供参考') }}</div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="section3">
                <div class="section3-inner rem-wrapper">
                    <h2 class="section2-title scroll-fade-up">{{ $t('activityListCreatorIncentives.800万交易者的信任首选') }}
                    </h2>
                    <p class="title-intro scroll-fade-up">
                        {{ $t('activityListCreatorIncentives.EBC用全球最佳券商的实力') }}

                    </p>
                    <div class="section3-list">
                        <div :class="{ 'section3-item-actived': section3Actived == 0 }"
                            @mouseenter="section3Actived = 0" class="section3-item ">
                            <div class="section3-item-content">
                                <h3 class="section3-item-title">{{ $t('activityListCreatorIncentives.全方位媒体曝光') }}</h3>
                                <p class="section3-item-intro">
                                    {{ $t('activityListCreatorIncentives.我们以全球媒体资源') }}
                                </p>
                                <span class="iconfont icon-chevron_right"></span>
                            </div>
                            <img class="section3-item-img"
                                src="../assets/image/activity/creator-incentives/section3_banner1.jpg" alt="" />
                        </div>
                        <div :class="{ 'section3-item-actived': section3Actived == 1 }"
                            @mouseenter="section3Actived = 1" class="section3-item">
                            <div class="section3-item-content">
                                <h3 class="section3-item-title">{{ $t('activityListCreatorIncentives.全球最强交易环境') }}</h3>
                                <p class="section3-item-intro">
                                    {{ $t('activityListCreatorIncentives.打造极致交易体验') }}
                                </p>
                                <span class="iconfont icon-chevron_right"></span>
                            </div>
                            <img class="section3-item-img"
                                src="../assets/image/activity/creator-incentives/section3_banner2.jpg" alt="" />
                        </div>
                        <div :class="{ 'section3-item-actived': section3Actived == 2 }"
                            @mouseenter="section3Actived = 2" class="section3-item">
                            <div class="section3-item-content">
                                <h3 class="section3-item-title">{{ $t('activityListCreatorIncentives.专属客户经理') }}</h3>
                                <p class="section3-item-intro">
                                    {{ $t('activityListCreatorIncentives.我们为每位创作者配专属运营') }}

                                </p>
                                <span class="iconfont icon-chevron_right"></span>
                            </div>
                            <img class="section3-item-img"
                                src="../assets/image/activity/creator-incentives/section3_banner3.jpg" alt="" />
                        </div>
                    </div>
                </div>
            </section>
            <section class="section4">
                <div class="section4-inner rem-wrapper">
                    <h2 class="section4-title scroll-fade-up">{{ $t('activityListCreatorIncentives.如何成为创作者') }}</h2>
                    <p class="title-intro scroll-fade-up">
                        {{ $t('activityListCreatorIncentives.从内容创作到奖励提现') }}

                    </p>
                    <div class="section4-btn-box">
                        <a href="javascript:;" @click="toAdd()" class="ebc-btn-large section4-btn">{{
                            $t('activityListCreatorIncentives.立即加入') }}</a>
                    </div>
                    <div class="section4-steps">
                        <div class="section4-step step1">
                            <div class="section4-step-icon-box">
                                <img class="section4-step-icon"
                                    src="../assets/image/activity/creator-incentives/icon4.svg" alt="" />
                            </div>
                            <h3 class="section4-step-title">{{ $t('activityListCreatorIncentives.注册提交资料') }}</h3>
                        </div>
                        <span class="iconfont icon-chevron_right"></span>
                        <div class="section4-step step2">
                            <div class="section4-step-icon-box">
                                <img class="section4-step-icon"
                                    src="../assets/image/activity/creator-incentives/icon5.svg" alt="" />
                            </div>
                            <h3 class="section4-step-title">{{ $t('activityListCreatorIncentives.发布专业内容') }}</h3>
                        </div>
                        <span class="iconfont icon-chevron_right"></span>
                        <div class="section4-step step3">
                            <div class="section4-step-icon-box">
                                <img class="section4-step-icon"
                                    src="../assets/image/activity/creator-incentives/icon6.svg" alt="" />
                            </div>
                            <h3 class="section4-step-title">{{ $t('activityListCreatorIncentives.获取月度奖励') }}</h3>
                        </div>
                    </div>
                    <div class="section4-notice">
                        <h3 class="section4-notice-title">{{ $t('activityListCreatorIncentives.活动须知') }}</h3>
                        <p class="section4-notice-li" v-for="item in $t('activityListCreatorIncentives.notices')"
                            v-html="item">
                        </p>
                    </div>
                    <div class="section4-tips" v-if="$t('activityListCreatorIncentives.section4Tips')"
                        v-html="$t('activityListCreatorIncentives.section4Tips')">
                    </div>
                </div>
            </section>
        </div>
        <message-v3></message-v3>
        <page-footer></page-footer>
        <message-popup ref="messagePopup"></message-popup>
    </div>
</template>

<script>

const fadeUpObserve = new IntersectionObserver(
    (entries) => {
        entries.forEach((e) => {
            if (e.isIntersecting) {
                e.target.classList.add("in-view");
                fadeUpObserve.unobserve(e.target);
            }
        });
    },
    { threshold: 0 }
);
export default {
    data() {
        return {
            section2Actived: { label: "$11,000", value: "Lv.7" },
            section2List: [{ label: "$360", value: "Lv.1" },
            { label: "$890", value: "Lv.2" },
            { label: "$1,860", value: "Lv.3" },
            { label: "$3,185", value: "Lv.4" },
            { label: "$5,390", value: "Lv.5" },
            { label: "$8,800", value: "Lv.6" },
            { label: "$11,000", value: "Lv.7" }
            ],
            section3Actived: 0,
        }
    },
    methods: {
        messageShow() {
            this.$refs.messagePopup.show();
        },
        toAdd() {
            const targetSection = document.querySelector(".message-new");
            if (targetSection) {
                targetSection.scrollIntoView({
                    behavior: "smooth",
                });
            }
        }
    },
    mounted() {
        document
            .querySelectorAll(".scroll-fade-up")
            .forEach((el) => fadeUpObserve.observe(el));

    }
}
</script>
<style>
@import url("../assets/css/rem-container.css");
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap');

.section4-notice-li a {
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
}
</style>
<style scoped>
.scroll-fade-up {
    transform: translateY(80rem);
    opacity: 0;
    transition: transform 0.6s ease-out, opacity 0.1s ease-out;
}

.in-view {
    transform: translate(0);
    opacity: 1;
}

.rem-container h1 {
    color: var(--Text-Primary, #000);
    font-size: 80rem;
    font-style: normal;
    font-weight: 700;
    line-height: 88rem;
}

.th h1,
.ru h1,
.pt h1,
.ko h1 {
    font-size: 60rem;
    line-height: 1.25;
}

.rem-container h2 {
    color: var(--Text-Primary, #000);
    font-size: 48rem;
    font-style: normal;
    font-weight: 700;
    line-height: 56rem;
}

.ebc-btn-large {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 48rem;
    padding: 0 24rem;
    gap: 8rem;
    border-radius: 24rem;
    background: var(--Brand-Secondary-Red, #a52933);
    color: var(--Text-Primary_White, #fff);
    text-align: center;
    font-size: 16rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1;
}

.ebc-btn-large:hover {
    background: var(--Functional-Active-Hover, #cc333f);
    color: var(--Text-Primary_White, #fff);
}

.ebc-btn-large:active {
    background: var(--Functional-Active-Pressed, #7b1e26);
    color: var(--Text-Primary_White, #fff);
}

.ebc-btn-large .iconfont {
    font-size: 20rem;
    line-height: 1;
}

.ar .ebc-btn-large .iconfont {
    transform: rotate(180deg);
}

.section1 {
    height: 616rem;
}

.section1-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    gap: 50rem;
}

.section1 .h1-intro {
    margin-top: 24rem;
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
    font-size: 20rem;
    font-style: normal;
    font-weight: 400;
}

.section1-btn {
    margin-top: 96rem;
    padding: 0 24rem 0 30rem;
}

.section1-bg {
    width: 560rem;
    flex-shrink: 0;
}

.section2 {
    background: linear-gradient(180deg, #fafafa 0%, #fff 20%);
}

.section2-title,
.section3-title,
.section4-title {
    text-align: center;
}

.section2-inner,
.section3-inner,
.section4-inner {
    padding: 120rem 360rem;
}

.title-intro {
    margin-top: 24rem;
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
    text-align: center;
    font-size: 18rem;
    font-style: normal;
    font-weight: 400;
    line-height: 26rem;
}

.section2-content {
    margin-top: 80rem;
    padding: 38rem;
    border-radius: 20rem;
    background: var(--Neutral-BG_B, #f7f7f7);
    display: flex;
    justify-content: space-between;
    gap: 40rem;
}

.section2-list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 64rem;
}

.jp .section2-list {
    gap: 48rem;
}

.section2-item-icon {
    width: 32rem;
}

.section2-item-title {
    margin-top: 12rem;
    color: var(--Text-Primary, #000);
    font-size: 20rem;
    font-style: normal;
    font-weight: 500;
    line-height: 26rem;
}

.section2-item-intro {
    margin-top: 12rem;
    color: var(--Text-Primary, #000);
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: 22rem;
}

.section2-card {
    flex-shrink: 0;
    position: relative;
    height: 526rem;
    width: 730rem;
    padding: 68rem 46rem 60rem;
    border-radius: 16rem;
    background: #fff url("../assets/image/activity/creator-incentives/section2_bg.png");
    background-size: 640rem 385rem;
    background-repeat: no-repeat;
    background-position: center;
}

.ar .section2-card {
    background: #fff url("../assets/image/activity/creator-incentives/section2_bg_ar.png");
    background-size: 640rem 385rem;
    background-repeat: no-repeat;
    background-position: center;
}

.section2-card-box {
    position: absolute;
    left: 60rem;
    top: 70rem;
}

.ar .section2-card-box {
    left: unset;
    right: 60rem;
}

.section2-card-label {
    color: var(--Text-Primary, #000);
    font-size: 16rem;
    font-style: normal;
    font-weight: 500;
    line-height: 24rem;
}

.section2-card-actived-value {
    margin-top: 8rem;
    color: var(--Brand-Secondary-Red, #a52933);
    font-size: 48rem;
    font-style: normal;
    font-weight: 700;
    line-height: 48rem;
}

.section2-card-list {
    display: flex;
    align-items: flex-end;
    height: 100%;
    width: 100%;
}

.section2-card-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    flex-shrink: 0;
    width: 14.28%;
    /* height: 100%; */
}

.section2-card-item-value {
    margin-bottom: 15rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 28rem;
    padding: 0 12rem;
    color: var(--Text-Primary_White, #fff);
    background: #b8987a;
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    border-radius: 6rem;
    transition: all 0.3s;
}

.section2-card-item-line {
    border-left: 1px dashed transparent;
    /* transform: translate(1px); */
    transition: all 0.3s;
}

.lv-1 .section2-card-item-line {
    height: 90rem;
}

.lv-2 .section2-card-item-line {
    height: 102rem;
}

.lv-3 .section2-card-item-line {
    height: 120rem;
}

.lv-4 .section2-card-item-line {
    height: 146rem;
}

.lv-5 .section2-card-item-line {
    height: 178rem;
}

.lv-6 .section2-card-item-line {
    height: 222rem;
}

.lv-7 .section2-card-item-line {
    height: 287rem;
}

.section2-card-item-dot {
    width: 14rem;
    height: 14rem;
    border-radius: 50%;
    border: 3px solid #b8987a;
    background-color: #fff;
    transition: all 0.3s;
}

.section2-card-item-level {
    margin-bottom: 32rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 50rem;
    height: 26rem;
    border-radius: 13rem;
    color: var(--Brand-Secondary-Red, #a52933);
    background: var(--Neutral-BG_A, #fff);
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    transition: all 0.3s;
}

.section2-card-item-actived .section2-card-item-value,
.section2-card-item:hover .section2-card-item-value {
    background: var(--Brand-Secondary-Red, #a52933);
}

.section2-card-item-actived .section2-card-item-dot,
.section2-card-item:hover .section2-card-item-dot {
    border-color: #a52933;
}

.section2-card-item-actived .section2-card-item-line,
.section2-card-item:hover .section2-card-item-line {
    border-left: 1px dashed #a52933;
}

.section2-card-item-actived .section2-card-item-level,
.section2-card-item:hover .section2-card-item-level {
    color: var(--Text-Primary_White, #fff);
    background: var(--Brand-Secondary-Red, #a52933);
}

.section2-card-tips {
    position: absolute;
    right: 48rem;
    bottom: 50rem;
    color: var(--Text-Tertiary, rgba(0, 0, 0, 0.48));
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: 22rem;
}

.section3 {
    background: var(--Neutral-BG_B, #f7f7f7);
}

.section3-list {
    margin-top: 80rem;
    position: relative;
    display: flex;
    justify-content: space-between;
}

.section3-item {
    display: flex;
    justify-content: space-between;
    padding: 28rem 40rem 32rem 40rem;
    flex-shrink: 0;
    width: 18.5%;
    height: 320rem;
    border-radius: 16rem;
    background: var(--Neutral-BG_A, #fff);
    overflow: hidden;
    transition: all 0.5s ease;
}

.section3-item-actived {
    padding: 28rem 28rem 32rem 40rem;
    width: 58.33%;
}

.section3-item-content {
    position: relative;
    max-width: 280rem;
}

.section3-item .icon-chevron_right {
    position: absolute;
    bottom: 0;
    font-size: 32rem;
    color: #c2c2c2;
}

.ar .section3-item .icon-chevron_right {
    transform: rotate(180deg);
}

.section3-item-title {
    margin-top: 16rem;
    color: var(--Text-Primary, #000);
    font-size: 24rem;
    font-style: normal;
    font-weight: 500;
    line-height: 36rem;
    transition: all 0.3s ease;
    /* 添加过渡效果 */
}

.section3-item-intro {
    display: none;
    margin-top: 16rem;
    color: var(--Text-Primary, #000);
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: 22rem;
    /* max-height: 0;  */
    width: 280rem;
    opacity: 0;
    overflow: hidden;
    transition: all 0.3s ease;
    /* 过渡效果 */
}

.section3-item-img {
    flex-shrink: 0;
    width: 0;
    height: 0;
    /* 初始状态 */
    border-radius: 12rem;
    object-fit: cover;
    overflow: hidden;
    opacity: 0;
    transition: all 0.3s ease;
    /* 过渡效果 */
}

.section3-item-actived .section3-item-title {
    /* 可根据需要添加激活状态的标题样式 */
}

.section3-item-actived .section3-item-intro {
    /* max-height: 200rem; 设置足够大的值容纳内容 */
    opacity: 1;
    display: block;
}

.section3-item-actived .section3-item-img {
    height: 264rem;
    /* 恢复原始高度 */
    width: 264rem;
    opacity: 1;
}

.section3-item-actived .icon-chevron_right {
    opacity: 0;
    height: 0;
}

.section4-btn-box {
    margin-top: 40rem;
    display: flex;
    justify-content: center;
}

.section4-btn {
    padding: 0 48rem;
}

.section4-steps {
    margin-top: 64rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.section4-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 363rem;
    padding: 0 50rem;
    height: 236rem;
    border-radius: 16rem;
    background: var(--Neutral-BG_B, #f7f7f7);
}

.es .section4-step,
.ru .section4-step,
.ug .section4-step,
.mn .section4-step {
    padding: 0 40rem;
    height: 256rem;
}

.section4-step-icon-box {
    flex-shrink: 0;
    margin-top: 48rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80rem;
    height: 80rem;
    border-radius: 50%;
    background-color: #fff;
}

.en .section4-step-icon-box {
    margin-top: 30rem;
}

.section4-step-icon {
    width: 40rem;
    height: 40rem;
}

.section4-step-title {
    margin-top: 24rem;
    color: var(--Text-Primary, #000);
    font-size: 24rem;
    font-style: normal;
    font-weight: 500;
    line-height: 36rem;
    text-align: center;
}

.section4-steps .icon-chevron_right {
    font-size: 32rem;
    color: #c2c2c2;
}

.ar .section4-steps .icon-chevron_right {
    transform: rotate(180deg);
}

.step1 {
    background-image: url("../assets/image/activity/creator-incentives/1.png");
    background-repeat: no-repeat;
    background-size: 138rem 103rem;
    background-position: right bottom;
}

.step2 {
    background-image: url("../assets/image/activity/creator-incentives/2.png");
    background-repeat: no-repeat;
    background-size: 138rem 103rem;
    background-position: right bottom;
}

.step3 {
    background-image: url("../assets/image/activity/creator-incentives/3.png");
    background-repeat: no-repeat;
    background-size: 138rem 103rem;
    background-position: right bottom;
}

.section4-notice {
    margin-top: 64rem;
    padding: 48rem 40rem;
    border-radius: 16rem;
    background: var(--Neutral-BG_B, #f7f7f7) url("../assets/image/activity/creator-incentives/notice.png");
    background-repeat: no-repeat;
    background-size: 444rem 77rem;
    background-position: right bottom;
}

.section4-notice-title {
    color: var(--Text-Primary, #000);
    font-size: 24rem;
    font-style: normal;
    font-weight: 500;
    line-height: 36rem;
}

.section4-notice-li {
    margin-top: 24rem;
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: 24rem;
}

.section4-notice-li a {
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
}

.section4-notice-li+.section4-notice-li {
    margin-top: 8rem;
}

.section4-tips {
    margin-top: 64rem;
    color: var(--Text-Quaternary, rgba(0, 0, 0, 0.24));
    text-align: left;
    font-size: 12rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

@media (max-width: 996px) {

    .section2-inner,
    .section3-inner,
    .section4-inner {
        padding: 120rem 32rem;
    }

    .rem-container h1 {
        font-size: 64rem;
        font-weight: 700;
        line-height: 80rem;
        text-align: center;
    }

    .rem-container h2 {
        font-size: 48rem;
        font-style: normal;
        font-weight: 700;
        line-height: 72rem;
    }

    .ebc-btn-large {
        height: 96rem;
        border-radius: 48rem;
        font-size: 32rem;
        font-style: normal;
        font-weight: 500;
        line-height: 56rem;
        padding: 0 48rem;
        width: 100%;
    }

    .section1 {
        height: auto;
    }

    .section1-inner {
        padding-top: 80rem;
        padding-bottom: 112rem;
        flex-direction: column;
        gap: 16rem;
    }

    .section1-left {
        order: 2;
    }

    .section1-bg {
        width: 603 rem;
        order: 1;
    }

    .ebc-btn-large .iconfont {
        font-size: 40rem;
    }

    .section1 .h1-intro {
        margin-top: 16rem;
        font-size: 28rem;
        line-height: 44rem;
        padding: 0 50rem;
        text-align: center;
    }

    .section2-content {
        margin-top: 80rem;
        padding: 0;
        flex-direction: column;
        background: none;
        gap: 100rem;
    }

    .title-intro {
        margin-top: 16rem;
        color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
        padding: 0 50rem;
        font-size: 24rem;
        font-style: normal;
        font-weight: 400;
        line-height: 40rem;
    }

    .jp .section2-list,
    .section2-list {
        order: 2;
        padding: 80rem 32rem;
        gap: 80rem;
        border-radius: 32rem;
        background: var(--Neutral-BG_B, #f7f7f7);
    }

    .section2-item {
        position: relative;
        padding-left: 80rem;
    }

    .ar .section2-item {
        padding-left: unset;
        padding-right: 80rem;
    }

    .section2-item-title {
        margin-top: 0;
        font-size: 36rem;
        font-weight: 500;
        line-height: 52rem;
    }

    .section2-item-intro {
        margin-top: 16rem;
        color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
        font-size: 28rem;
        font-weight: 400;
        line-height: 44rem;
    }

    .section2-item-icon {
        position: absolute;
        left: 0;
        top: 2rem;
        width: 56rem;
        height: 56rem;
    }

    .ar .section2-item-icon {
        left: unset;
        right: 0;
    }

    .section2-card {
        width: 686rem;
        height: 770rem;
        padding: 0;
        background: #fff url("../assets/image/activity/creator-incentives/section2_bg_m.png");
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: center;
    }

    .ar .section2-card {
        background: #fff url("../assets/image/activity/creator-incentives/section2_bg_m_ar.png");
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: center;
    }

    .section2-card-box {
        left: 0;
        top: 0;
    }

    .section2-card-label {
        font-size: 28rem;
        font-weight: 500;
        line-height: 44rem;
    }

    .section2-card-actived-value {
        font-size: 72rem;
        line-height: 80rem;
    }

    .section2-card-item-level {
        height: 50rem;
        width: 75rem;
        border-radius: 25rem;
        font-size: 24rem;
    }

    .section2-card-item-dot {
        width: 30rem;
        height: 30rem;
    }

    .lv-1 .section2-card-item-line {
        height: 190rem;
    }

    .lv-2 .section2-card-item-line {
        height: 214rem;
    }

    .lv-3 .section2-card-item-line {
        height: 250rem;
    }

    .lv-4 .section2-card-item-line {
        height: 301rem;
    }

    .lv-5 .section2-card-item-line {
        height: 370rem;
    }

    .lv-6 .section2-card-item-line {
        height: 463rem;
    }

    .lv-7 .section2-card-item-line {
        height: 592rem;
    }

    .section2-card-item-value {
        color: #b8987a;
        font-size: 28rem;
        font-weight: 500;
        line-height: 44rem;
        background: none;
    }

    .section2-card-item-actived .section2-card-item-value,
    .section2-card-item:hover .section2-card-item-value {
        background: none;
        color: #a52933;
    }

    .section2-card-tips {
        left: 0;
        bottom: -40rem;
        font-size: 28rem;
        font-weight: 400;
        line-height: 44rem;
        text-align: center;
    }

    .section3-list {
        flex-direction: column;
        gap: 32rem;
    }

    .section3-item,
    .section3-item-actived {
        flex-direction: column;
        width: 100%;
        height: auto;
        border-radius: 32rem;
        padding: 56rem 32rem;
    }

    .section3-item-content {
        max-width: unset;
    }

    .section3-item-title {
        margin-top: 0;
        font-size: 36rem;
        font-weight: 500;
        line-height: 52rem;
    }

    .section3-item .icon-chevron_right {
        display: none;
    }

    .section3-item-actived .section3-item-img,
    .section3-item-img {
        margin-top: 48rem;
        width: unset;
        height: unset;
        opacity: 1;
    }

    .section3-item-actived .section3-item-intro,
    .section3-item-intro {
        display: block;
        font-size: 28rem;
        font-weight: 400;
        line-height: 48rem;
        opacity: 1;
        max-height: unset;
        width: unset;
    }

    .section4-btn {
        width: auto;
        min-width: 330rem;
    }

    .section4-steps {
        margin-top: 80rem;
        flex-direction: column;
    }

    .es .section4-step,
    .ru .section4-step,
    .ug .section4-step,
    .mn .section4-step,
    .section4-step {
        width: 100%;
        flex-direction: row;
        height: 224rem;
        gap: 32rem;
        background-size: 235rem 176rem;
        border-radius: 32rem;
    }

    .section4-step-icon-box {
        margin-top: 0;
        width: 96rem;
        height: 96rem;
    }

    .en .section4-step-icon-box {
        margin-top: 0;
    }

    .section4-step-icon {
        width: 48rem;
        height: 48rem;
    }

    .section4-step-title {
        margin-top: 0;
        font-size: 36rem;
        line-height: 52rem;
        text-align: left;
    }

    .ar .section4-steps .icon-chevron_right,
    .section4-steps .icon-chevron_right {
        font-size: 48rem;
        transform: rotate(90deg);
        margin: 8rem;
    }

    .section4-notice {
        margin-top: 160rem;
        padding: 80rem 32rem;
        border-radius: 32rem;
    }

    .section4-notice-title {
        text-align: center;
        font-size: 36rem;
        line-height: 52rem;
    }

    .section4-notice-li {
        margin-top: 32rem;
        font-size: 28rem;
        line-height: 48rem;
    }

    .section4-notice-li+.section4-notice-li {
        margin-top: 16rem;
    }

    .section4-tips {
        margin-top: 80rem;
        font-size: 24rem;
    }
}
</style>